import { Injectable, signal, Signal } from '@angular/core';
import { UserDto } from '@web/dtos';

@Injectable({
  providedIn: 'root',
})
export class MockUserStore {
  readonly user: Signal<UserDto | undefined> = signal(undefined);
  readonly isLoading: Signal<boolean> = signal(false);

  deleteAccount(): any {}

  updateUser(userData: UserDto): void {}

  updateUserResource(query: UserDto): void {}
}
